const formatAmount = (amount: number, currencyPrecision: number): string =>
    amount.toFixed(currencyPrecision);

export default formatAmount;
